// select2 — its minified UMD, under a bundler, takes the CommonJS branch and *exports
// an installer factory* rather than self-installing. Call it explicitly against the
// shared jQuery. Kept in its own module so the install call lives with the select2
// import + CSS (a bare statement can't sit among the other side-effect imports in
// jquery-stack.ts without tripping eslint's import/first rule).
import installSelect2 from 'databox-select2/dist/js/select2.full.min.js';

import $ from 'webapp/vendor/jquery-globals';

import 'databox-select2/dist/css/select2.min.css';

installSelect2(window, $);
